import { Parameter } from 'types/classifiers';
import { t } from 'utils/getTranslations';

const hiddenClassifierValuesMap = new Map([
    ['TASK_TYPE', new Set(['CORRESPONDENCE'])],
    ['COMPLIANCE_VERIFICATION_STATUS_TYPE', new Set(['NOT_NEEDED', 'EXPIRED'])],
    // A client identification is started from the client, never picked as a contract type.
    ['CONTRACT_TYPE', new Set(['CLIENT_IDENTIFICATION'])],
]);

export const isHiddenClassifierValue = (classifierCode: string, valueCode: string): boolean => {
    return hiddenClassifierValuesMap.get(classifierCode)?.has(valueCode) || false;
};

// camelCase key -> spaced, capitalised label, e.g. "multiplierRate" -> "Multiplier Rate"
const humanizeParameterKey = (key: string): string =>
    key.replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/^./, (char) => char.toUpperCase());

const formatParameterValue = (value: unknown): string => {
    if (Array.isArray(value)) return value.join(', ');
    if (typeof value === 'boolean') return value ? t('yes') : t('no');
    if (value !== null && typeof value === 'object') return JSON.stringify(value);
    return String(value);
};

// Renders the parameters json into a readable "Label: value, Label: value" string.
export const formatClassifierParameters = (parameters?: Parameter | null): string => {
    if (!parameters || typeof parameters !== 'object') return '';
    return Object.entries(parameters)
        .filter(([, value]) => value !== null && value !== undefined)
        .map(([key, value]) => `${humanizeParameterKey(key)}: ${formatParameterValue(value)}`)
        .join(', ');
};
